export default __webpack_public_path__ + "bb816fd45113ef57737a390d63e03a62.png";